export const USAPhoneNumberFormate = (phone) => {
  const cleaned = `${phone}`.replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "" : "";
    const number = [
      intlCode,
      "(",
      match[2],
      ") ",
      match[3],
      "-",
      match[4],
    ].join("");

    return number;
  }
  return phone;
};

export const getPrevDollorFormattedString = (val) => {
  if ((!val && val !== 0) || isNaN(val)) {
    return "  -";
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(val);
};

export const getPostPercentFormattedString = (val) => {
  if (!val || isNaN(val)) {
    return "  -";
  }
  return String(val) + " %";
};

export const objectToString = (obj, { separator = " : " } = {}) => {
  if (obj === null || typeof obj !== "object" || Array.isArray(obj)) {
    return String(obj);
  }

  const entries = Object.entries(obj);
  if (entries.length === 0) {
    return "";
  }
  const longestKeyLength = entries.reduce((max, [key]) => {
    return key.length > max ? key.length : max;
  }, 0);

  const lines = entries.map(([key, value]) => {
    const paddedKey = key.padEnd(longestKeyLength, " ");
    const stringValue =
      typeof value === "object" && value !== null
        ? JSON.stringify(value)
        : String(value);

    return `${paddedKey}${separator}${stringValue}`;
  });
  return lines.join("\n");
};
